import app from 'flarum/common/app';
import Component from 'flarum/common/Component';
import languageName from '../utils/languageName';
export default class TranslationLabel extends Component {
  view() {
    const {
      sourceLanguage
    } = this.attrs;
    if (!sourceLanguage) {
      return app.translator.trans('glowingblue-translate.lib.translation.label.translated');
    }
    return app.translator.trans('glowingblue-translate.lib.translation.label.translated_from', {
      language: languageName(sourceLanguage)
    });
  }
}
flarum.reg.add('glowingblue-translate', 'common/components/TranslationLabel', TranslationLabel);